<style>
/* @import url("https://vjs.zencdn.net/7.2.4/video-js.css"); */
</style>
<style lang="less">
@import "../../styles/common.less";
@import "./layout.less";
</style>


<template>
  <div>
    <header-and-footer>
      <div class="duckbill-cms-main">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </div>
    </header-and-footer>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import axios from "axios";
import util from "../../libs/util";
// 引入富文本编辑器
// import E from 'wangeditor'; // npm原包的
import E from "../../libs/wangEditor"; // 自定义修改过的
import videojs from "video.js";
// 车牌号正则
const REGEXP = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$/;
import imageViewer from "../../components/image-viewer";
import scrollBar from "../../components/scroll-bar";
import $ from "jquery";
//版头版尾
import headerAndFooter from "../../components/header-and-footer";

export default {
  components: {
    "image-viewer": imageViewer,
    "scroll-bar": scrollBar,
    "header-and-footer": headerAndFooter
  },
  data: () => {
    return {

      // user信息
      user: {},
      // footer的高度
      // footerHeight: `${document.documentElement.clientHeight - 761}px`
      // 用户协议弹框
    };
  },
  mounted() {
    },

  watch: {
    $route: "getParamsFromRoute"
  },
  methods: {
    getParamsFromRoute(value) {
      if (this.$route.name === "index") {
        if (!util.isEmptyObject(this.$route.query)) {
          if (this.$route.query.s) {
            let code = this.$route.query.s;
            Cookies.set("BD_CODE", code);
          }
        }
      }
    },
  }
};
</script>

<style>
.look-picture .image-viewer {
  background: white !important;
}
</style>


// WEBPACK FOOTER //
// layout.vue?004e970c